import { getUnreadThreadMessageCountByIds, GetUnreadThreadMessageCountByIdsVariables } from "src/aws/customAPI"
import { execApi } from "src/apis/execApi"
import { appInfo } from "src/constants/AppInfo"

type Params = {
  accessToken: string
  accountId: string
  contactIds?: string[]
}

/**
 * OpenSearchを使用して未読カウントを取得（従来の実装）
 * @deprecated FeatureFlag移行後、OpenSearchスケールダウン時に削除予定
 */
export const getUnreadThreadCountFromOpenSearch = async ({
  accessToken,
  accountId,
  contactIds,
}: Params): Promise<any> => {
  const variables: GetUnreadThreadMessageCountByIdsVariables = contactIds == null ? {
    aggrUnit: 'account',
    accountId
  } : {
    aggrUnit: 'mail',
    accountId,
    mailIds: contactIds
  }

  const result = await execApi(
    () => getUnreadThreadMessageCountByIds(accessToken, {
      ...variables,
      appInfo
    }),
    (res) => res.searchThreadMessages?.aggregateItems?.[0]?.result
  )

  return result.isOk ? result.content : { buckets: [] }
}
